import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b93ad35"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CategoryGroupPop" }
const _hoisted_2 = { class: "CategoryGroupPop-list" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "item-content" }
const _hoisted_5 = { class: "item-content-row-label" }
const _hoisted_6 = { class: "item-content-row-value" }
const _hoisted_7 = ["href"]

import { t } from '@/plugins/i18n'


import { Site } from '@/common/const'
import { useSite2Station } from '@/store'


export default /*#__PURE__*/_defineComponent({
  props: {
  groupData: {
    type: Array as () => Array<any>,
    default: () => []
  }
},
  setup(__props) {

const props = __props
const stationCode = useSite2Station()



// 接收数组，随机截取指定长度的item
const randomSliceList = (arr: any, count: number) => {
  const shuffled = arr.slice(0)
  let i = arr.length
  const min = i - count
  if (min <= 0) {
    return arr
  }
  let temp
  let index
  while (i-- > min) {
    index = Math.floor((i + 1) * Math.random())
    temp = shuffled[index]
    shuffled[index] = shuffled[i]
    shuffled[i] = temp
  }
  return shuffled.slice(min)
}

// 根据group长度，判断展示几行类目
const judgeRowByGroup = (length: number) => {
  if (length >= 3) {
    return 3
  } else
  if (length === 2) {
    return 5
  } else {
    return 10
  }
}

// 数组根据指定字段去重
const arrayNoRepeatByKey = (arr: any, key: any) => {
  const map = new Map()
  for (const item of arr) {
    map.set(item[key], item)
  }
  return [...map.values()]
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.groupData, (firstItem) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "CategoryGroupPop-list-item",
          key: firstItem.id
        }, [
          _createElementVNode("a", {
            class: "item-title",
            href: firstItem.first_url,
            target: "_blank"
          }, _toDisplayString(_unref(stationCode)=== _unref(Site).JA ? firstItem.first_name_ja : _unref(t)(firstItem.first_name)) + _toDisplayString(_unref(t)('市场')), 9, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(randomSliceList(firstItem.child, judgeRowByGroup(__props.groupData.length)), (groupItem) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item-content-row",
                key: groupItem.name
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(stationCode)=== _unref(Site).JA ? groupItem.first_name_ja : _unref(t)(groupItem.first_name)), 1),
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(randomSliceList(arrayNoRepeatByKey(groupItem.child, 'second_name_ja'), 5), (secondItem) => {
                    return (_openBlock(), _createElementBlock("a", {
                      href: secondItem.second_url,
                      target: "_blank",
                      key: secondItem.id
                    }, _toDisplayString(_unref(stationCode)=== _unref(Site).JA ? secondItem.first_name_ja : _unref(t)(secondItem.first_name)), 9, _hoisted_7))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})